import { useState } from '#imports'

import type { Locale } from '@backmarket/http-api'

import { NUXT_STATE_KEY } from '../constants'
import type { I18nState } from '../types'

/**
 * @returns The current locale used by the translation system.
 *
 * @example
 * const locale = useI18nLocale()
 */
export function useI18nLocale() {
  // FIXME: We should not cast the value to `Locale`. This is likely wrong
  // FIXME: since the returned value looks like `en-us`, not `en_US`.
  return useState<I18nState>(NUXT_STATE_KEY).value.locale as Locale
}
